import React from 'react';
import styled from 'styled-components';
import { FlexColumn } from '@ubeya/shared-web/components';
import { maxMedia, media } from '@ubeya/shared-web/style';
import ClientComments from './Comments/ClientComments';

const Details = styled(FlexColumn)`
  position: relative;
  overflow: scroll;
  flex: 2;
  padding: 0 200px 44px 200px;
  width: 100%;
  height: 100%;
  ${media.tablet`overflow: auto;`}
  ${maxMedia.tablet`
    flex-direction: column;
  `};
  ${maxMedia.mobile`
    padding: 0 10px 44px 10px;
  `};
  margin-top: 40px;
`;

export const CommentsTab = ({ clientId }) => {
  if (!clientId) {
    return null;
  }
  return (
    <Details>
      <ClientComments clientId={clientId} />
    </Details>
  );
};
